<div class="screen">
  <div class="screen-inner">
    @if (broadcast) {
      <header class="topbar">
        <span></span>
        <h1 class="topbar-title">{{ headline() }}</h1>
        <span></span>
      </header>
    } @else {
      <app-shell nav="back" action="menu" [title]="headline()" [backTo]="backTo()"></app-shell>
    }

    @if (board) {
      <p class="section-label">{{ subtitle() }}</p>

      @if (board.rows.length === 0) {
        <p class="page-note">No scores yet.</p>
      } @else {
        <div class="card">
          @for (row of board.rows; track row.competitorId) {
            <div class="lb-item">
              <button type="button" class="lb-row lb-expandable" [class.row-highlight]="isMe(row)" [attr.aria-expanded]="isOpen(row)" (click)="toggle(row)">
                <span class="lb-rank">{{ row.rank }}</span>
                <span class="lb-name">
                  {{ row.name }}
                  @if (board.usesRunningTee && row.currentTeeName) {
                    <span class="lb-tee">{{ row.currentTeeName }}</span>
                  }
                </span>
                <span class="lb-topar" [class.lb-ns]="noScore(row)">{{ scoreLabel(row) }}</span>
                <span class="lb-hole" [class.lb-time]="row.lastHole == null && !!row.teeTime" [class.lb-warn]="missingTeeTime(row)">{{ holeLabel(row) }}</span>
              </button>
              @if (isOpen(row)) {
                <div class="lb-detail">
                  <p class="lb-detail-name">{{ row.detailName || row.name }}</p>
                  @if (row.tiebreaker) {
                    <button type="button" class="lb-tie-link" (click)="showTiebreaker(row)">Show Tiebreaker</button>
                  }
                  @if (row.keeps) {
                    <div class="lb-keeps">
                      @for (item of row.keeps; track item.par) {
                        <div class="keep-stat" [class.keep-done]="item.kept >= item.need">
                          <span class="keep-par">Par {{ item.par }}</span>
                          <span class="keep-count">{{ item.kept }} of {{ item.need }} kept</span>
                          <span class="keep-discard">{{ item.discarded }} discarded</span>
                        </div>
                      }
                    </div>
                  }
                  @if (playedHoles(row).length === 0) {
                    <p class="lb-card-empty">No holes yet.</p>
                  } @else {
                    <div class="lb-card">
                      @if (teamCard(row)) {
                        <div class="lb-card-row lb-card-team lb-card-head" [ngClass]="playerCountClass(row)">
                          <span></span>
                          <span></span>
                          @for (player of cardPlayers(row); track player.name) {
                            <span class="lb-player-cell">
                              <span></span>
                              <span class="lb-card-player">{{ player.name }}</span>
                              <span></span>
                            </span>
                          }
                          <span class="lb-card-player lb-team-label">Team</span>
                        </div>
                      }
                      @for (hole of playedHoles(row); track hole.sequence) {
                        @if (teamCard(row)) {
                          <div class="lb-card-row lb-card-team" [ngClass]="playerCountClass(row)">
                            <span class="lb-card-hole">{{ hole.hole }}</span>
                            <span class="lb-card-meta">Par {{ hole.par }}</span>
                            @for (player of hole.players ?? []; track player.name) {
                              <span class="lb-player-cell">
                                <span class="lb-card-marks">
                                  @if (player.strokes > 0) {
                                    @for (dot of strokeDots(player.strokes); track dot) {
                                      <span class="sc-dot"></span>
                                    }
                                  }
                                  @if (player.strokes < 0) {
                                    <span class="lb-card-give">{{ givenMarks(player.strokes) }}</span>
                                  }
                                </span>
                                <span class="lb-player-gross">{{ player.gross ?? '–' }}</span>
                                <span class="lb-card-net">{{ player.gross != null && player.net != null && player.net !== player.gross ? player.net : '' }}</span>
                              </span>
                            }
                            <span class="lb-team-score">{{ hole.gross ?? '–' }}</span>
                          </div>
                        } @else {
                          <div class="lb-card-row">
                            <span class="lb-card-hole">
                              <span>{{ hole.hole }}</span>
                              @if (hole.strokes > 0) {
                                <span class="lb-card-marks">
                                  @for (dot of strokeDots(hole.strokes); track dot) {
                                    <span class="sc-dot"></span>
                                  }
                                </span>
                              }
                              @if (hole.strokes < 0) {
                                <span class="lb-card-give">{{ givenMarks(hole.strokes) }}</span>
                              }
                            </span>
                            <span class="lb-card-meta">Par {{ hole.par }}</span>
                            <span class="lb-card-score">
                              {{ hole.kept === false ? 'Out' : hole.gross }}
                              @if (hole.kept !== false && hole.net != null) {
                                <span class="lb-card-net">{{ hole.net }}</span>
                              }
                            </span>
                          </div>
                        }
                      }
                      @if (teamCard(row)) {
                        <div class="lb-card-row lb-card-team lb-card-total" [ngClass]="playerCountClass(row)">
                          <span class="lb-card-hole">Tot</span>
                          <span></span>
                          @for (player of cardPlayers(row); track player.name; let index = $index) {
                            <span class="lb-player-cell">
                              <span></span>
                              <span class="lb-player-gross">{{ playerGrossTotal(row, index) }}</span>
                              <span class="lb-card-net">{{ playerNetTotal(row, index) !== playerGrossTotal(row, index) ? playerNetTotal(row, index) : '' }}</span>
                            </span>
                          }
                          <span class="lb-team-score">{{ teamTotal(row) }}</span>
                        </div>
                      } @else {
                        <div class="lb-card-row lb-card-total">
                          <span class="lb-card-hole">Tot</span>
                          <span></span>
                          <span class="lb-card-score">
                            {{ grossTotal(row) }}
                            <span class="lb-card-net">{{ netTotal(row) }}</span>
                          </span>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }

      @if (sideGames.length > 0) {
        <p class="section-label">Side games</p>
        <div class="card">
          @for (game of sideGames; track game.label) {
            <div class="row row-static">
              <span class="row-body">
                <span class="row-title">{{ game.name }}</span>
                <span class="row-meta">{{ game.label }}</span>
              </span>
            </div>
          }
        </div>
      }

      @if (!broadcast && board.firstRoundId) {
        <a class="btn-primary" [routerLink]="['/events', eventId, 'score', board.firstRoundId]">Enter my score</a>
        <a class="btn-secondary btn-block" [routerLink]="['/events', eventId, 'score', board.firstRoundId, 'card']">Scorecard</a>
      }
    }

    @if (error) { <p class="error">{{ error }}</p> }
  </div>

  @if (tieRow?.tiebreaker; as tie) {
    <div class="modal-back" (click)="closeTiebreaker()">
      <div class="modal" role="dialog" aria-labelledby="tie-title" (click)="$event.stopPropagation()">
        <h2 id="tie-title">Tiebreaker</h2>
        <p>{{ tieIntro(tieRow!) }}</p>
        @for (step of tie.steps; track $index) {
          <p class="modal-label">{{ step.description }}</p>
          @for (score of step.scores; track score.competitorId) {
            <p class="modal-score">{{ score.name }}: {{ score.score }}</p>
          }
          <p class="modal-summary" [class.modal-winner]="step.result === 'split'">{{ step.summary }}</p>
        }
        <p class="modal-label">Final result</p>
        @for (person of tie.order; track person.competitorId) {
          <p class="modal-score">{{ person.rank }}. {{ person.name }}</p>
        }
        <button class="btn-secondary" type="button" (click)="closeTiebreaker()">Close</button>
      </div>
    </div>
  }
</div>
